/*
 * @Descripttion: 
 * @Author: heng.wu
 * @Date: 2022-8-9 14:26:29
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2022-8-9 14:26:21
 */
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 查询梯控列表
export const iotElevatorQuery = (params:any) => {
  return https().request('iot/elevator', Method.GET, params, ContentType.form)
}

// 查询梯控分组
export const groupQuery = (params:any) => {
  return https().request('iot/elevator/group', Method.GET, params, ContentType.form)
}

// 添加梯控
export const iotElevatorAdd = (params:any) => {
  return https().request('iot/elevator', Method.POST, params, ContentType.json)
}

// 编辑梯控
export const iotElevatorEdit = (params:any) => {
  return https().request('iot/elevator', Method.PUT, params, ContentType.json)
}

// 删除梯控
export const iotElevatorDelete = (params:any) => {
  return https().request('iot/elevator', Method.DELETE, params, ContentType.form)
}
